import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import { CardSliceData } from 'types/card/card-list';

const initialState: CardSliceData = {
    cardName: '',
    fileId: '',
    allowedGamesCard: [],
    code: '',
};

const newCardDataSlice = createSlice({
    name: 'cardData',
    initialState,
    reducers: {
        addNewCardData: (state, action: PayloadAction<CardSliceData>) => {
            state.fileId = action.payload.fileId || '';
            state.cardName = action.payload.cardName;
            state.allowedGamesCard = action.payload.allowedGamesCard;
            state.code = action.payload.code;
        },
        deleteCardData: (state) => {
            state.fileId = '';
            state.cardName = '';
            state.allowedGamesCard = [];
        },
    },
});

export const { addNewCardData, deleteCardData } = newCardDataSlice.actions;

export const selectNewCardDataSliceOptions = (state: RootState) =>
    state.cardData;

export default newCardDataSlice.reducer;
